import Icon, { type IconProps } from './Icon';

export default Icon;
export type { IconProps };
